import React, { useState, useEffect } from "react";
import { Select } from "antd";

const SelectNivelEscolar = ({ setLevel, disabled, level }) => {
  const { Option } = Select;

  const list = ["INICIAL", "PRIMARIA", "SECUNDARIA"];

  const removeAccents = (str) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const renderOptions = () => {
    return list.map((i) => (
      <Option key={i} value={i} title={i.toUpperCase()}>
        {i.toUpperCase()}&nbsp;&nbsp;&nbsp;
      </Option>
    ));
  };

  const filterOptions = (inputValue, option) => {
    const title = removeAccents(option.props.title.toLowerCase());
    return title.includes(inputValue.toLowerCase());
  };

  return (
    <Select
      size="large"
      style={{ width: "100%" }}
      showSearch
      value={level}
      onChange={(e) => setLevel(e)}
      filterOption={filterOptions}
      disabled={disabled}
    >
      <Option key={0} value={null} title={""}>
        {" "}
        - Ninguno -{" "}
      </Option>
      {renderOptions()}
    </Select>
  );
};
export default SelectNivelEscolar;
